import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'

import { setFacility } from '../../actions/facilities/facilities.actions'

import { ListItem, ListItemText, Menu, MenuItem } from '@material-ui/core'

import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks'

import { makeStyles } from '@material-ui/core/styles'

import Logo from '../../assets/svg/logo'
import clsx from 'clsx'
import useCurrentUser from '../../hooks/useCurrentUser'

const useStyles = makeStyles((theme) => ({
	selectedFacility: {
		marginLeft: 10,
		fontSize: 16,
		color: '#FFFFFF',
		textTransform: 'uppercase',
		fontFamily: 'Nunito',
		fontWeight: 'bold'
	},

	logo: {
		height: 30
	},

	menu: {
		paddingLeft: 0,
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: '#3B0275',
			opacity: 0.6
		}
	},
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const FacilityList = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	let history = useHistory()
	let location = useLocation()

	const facilities = useSelector((state) => state.specific.facilities.facilities)
	const { isSuperUser, isBackOfficeUser, facilityId } = useCurrentUser()

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)

	const popupState = usePopupState({
		variant: 'popover',
		popupId: 'facilityMenu'
	})

	const assignedFacility = (facilities || []).find((facility) => String(facility._id) === String(facilityId))
	const lockedFacilityId = !isSuperUser && assignedFacility?.active ? facilityId : null

	const selectFacility = async (facility) => {
		if (lockedFacilityId && String(facility._id) !== String(lockedFacilityId)) return

		await dispatch(setFacility(facility))

		localStorage.setItem('facilityID', `${facility._id}`)
		history.push(`/facilities/${facility._id}/schedule`)
	}

	const hasGlobalAccess = isBackOfficeUser || isSuperUser
	const visibleFacilities = (facilities || []).filter((facility) => {
		if (!facility.active) return false
		if (lockedFacilityId) return String(facility._id) === String(lockedFacilityId)
		return true
	})

	return (
		<div>
			<ListItem className={clsx(classes.listItem, classes.menu)} {...bindTrigger(popupState)}>
				<Logo />
				<ListItemText
					className={classes.selectedFacility}
					primary={
						location && location.pathname.includes('/globalAdmin')
							? 'Global Admin'
							: selectedFacility
							? selectedFacility.name
							: 'Select Facility'
					}
				/>
				<i className={clsx('fa fa-chevron-down', classes.arrow)} />
			</ListItem>
			<Menu {...bindMenu(popupState)}>
				{hasGlobalAccess ? (
					<MenuItem
						className={classes.listItem}
						onClick={() => {
							popupState.close()
							history.push(`/globalAdmin/markets`)
						}}>
						<ListItemText primary="Global Admin" />
					</MenuItem>
				) : null}
				{visibleFacilities.map((facility) => {
							return (
								<MenuItem
									className={classes.listItem}
									onClick={() => {
										popupState.close()
										selectFacility(facility)
									}}
									key={facility._id}>
									<ListItemText primary={facility.name} />
								</MenuItem>
							)
					  })}
			</Menu>
		</div>
	)
}

export default FacilityList
